import React from 'react';
import config from '../../config/config';
import { APPLICATION_VARIANTS } from '../../constants';
import './GridLoadingSpinner.css';

/*
 * note: this component needs to be wrapped in a container(div) to be rendered
 */
const GridLoadingSpinner = plant => {
  return (
    <div
      className={
        config.APPLICATION_VARIANT === APPLICATION_VARIANTS.MES4
          ? 'la-ball-grid-pulse la-green la-3x'
          : 'la-ball-grid-pulse la-blue la-3x'
      }
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

GridLoadingSpinner.propTypes = {};

export default GridLoadingSpinner;
